export class ContractParticipants {
    organizationId: number;
    practiceId: number;
    providerId: number;
    checked: boolean;
    unChecked: boolean;
}